import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useGetAgentEnumerations } from "../../../common/api/queries/enumerations";
import { AgentType } from "../enums";
import { Agent } from "../types";
import { formatAgentName } from "../utils";

type Props = {
  agent: Agent;
};

export const AgentImportantInfo = ({ agent }: Props) => {
  const { t } = useTranslation();

  const { data } = useGetAgentEnumerations(agent.parent?.id ? [agent.parent.id] : []);
  const agentParentEnum = data?.[0];

  return (
    <div className="sub-header-info standard-text margin-bottom-small">
      {[
        {
          key: "directorate",
          content: agent.directorate ? (
            <>
              <span>{t("agent.attrs.directorate")}:</span> {agent.directorate.code}
            </>
          ) : undefined,
        },
        {
          key: "parent",
          content: agent.parent ? (
            <>
              <span>{t("agent.attrs.parentId")}:</span> {formatAgentName(agent.parent)}
            </>
          ) : undefined,
        },
        {
          key: "parentRepresentatives",
          content:
            agentParentEnum && agentParentEnum.type === AgentType.LEGAL && agentParentEnum.representatives?.length ? (
              <>
                <span>{t("agent.helpers.parentRepresentatives")}:</span>{" "}
                {agentParentEnum.representatives?.map((representative) => formatAgentName(representative)).join(", ")}
              </>
            ) : undefined,
        },
      ]
        .filter((item) => !!item.content)
        .reduce<React.ReactNode[]>((acc, item, index) => {
          if (index > 0) {
            acc.push(<Fragment key={`${item.key}-separator`}> | </Fragment>);
          }

          acc.push(<Fragment key={item.key}>{item.content}</Fragment>);
          return acc;
        }, [])}
    </div>
  );
};
